import { useState } from 'react'
import { Modal } from '@/components/ui/Modal'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import { toast } from 'sonner'
import api from '@/services/api'
import { getFriendlyError } from '@/utils/getFriendlyError'

type EmpresaCreateModalProps = {
  open: boolean
  onClose: () => void
  onCreated: () => void
}

export function EmpresaCreateModal({ open, onClose, onCreated }: EmpresaCreateModalProps) {
  const [nome, setNome] = useState('')
  const [cnpj, setCnpj] = useState('')
  const [saving, setSaving] = useState(false)

  const handleClose = () => {
    setNome('')
    setCnpj('')
    onClose()
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    const trimmed = nome.trim()
    if (!trimmed) {
      toast.error('Informe o nome da empresa')
      return
    }
    setSaving(true)
    try {
      await api.post('/empresas', {
        nome: trimmed,
        razaoSocial: trimmed,
        nomeFantasia: trimmed,
        cnpj: cnpj.trim() || undefined,
      })
      toast.success('Empresa criada com sucesso')
      onCreated()
      handleClose()
    } catch (error: unknown) {
      toast.error(getFriendlyError(error, 'Erro ao criar empresa'))
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal open={open} onClose={handleClose} title="Nova Empresa" size="md">
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          label="Nome / Razão social *"
          value={nome}
          onChange={(e) => setNome(e.target.value)}
          placeholder="Ex: Agrada Digital"
          required
        />
        <Input
          label="CNPJ (opcional)"
          value={cnpj}
          onChange={(e) => setCnpj(e.target.value)}
          placeholder="00.000.000/0001-00"
        />
        <div className="flex justify-end gap-2 pt-2">
          <Button type="button" variant="ghost" onClick={handleClose} disabled={saving}>
            Cancelar
          </Button>
          <Button type="submit" variant="primary" loading={saving}>
            Criar
          </Button>
        </div>
      </form>
    </Modal>
  )
}
